import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { MSpinner } from "components/Shared";
import { Button, TextField } from "react-md";
import logo from "static/images/logo.png";
import StarRatings from "react-star-ratings";
import { getFeedbackStatus, postBrokerFeedback } from "requests/caseFeedback";
import { Link } from "react-router-dom";
import responseHandler from "responseHandler";

let STATUS = {
  NONE: "NONE",
  FETCHING: "FETCHING",
  READY: "READY",
  RATED: "RATED",
  EXPIRED: "EXPIRED",
  ERROR: "ERROR",
};

const CustomerFeedback = (props) => {
  const mounted = useRef(true);
  const { match: { params }, makeToast } = props;  
  
  const [stars, setStars] = useState(0);
  const [comments, setComments] = useState("");
  const [status, setStatus] = useState(STATUS.NONE);

  const COMMENTS_MAXLENGTH = 500;

  const fetchStatus = () => {      
    getFeedbackStatus(
      params.workitemid, 
      (data) => { data ? setStatus(STATUS.READY) : setStatus(STATUS.EXPIRED); },
      () => { setStatus(STATUS.ERROR); },
      mounted
    );    
    setStatus(STATUS.FETCHING);
  };
  
  const submitFeedback = () => {  
    if(stars === 0){
      makeToast("Please select a star rating before submitting.");
      return;
    }
    if(comments.length > COMMENTS_MAXLENGTH){
      makeToast(`You have exceeded the character limit of ${COMMENTS_MAXLENGTH}.`);
      return;
    }
    
    postBrokerFeedback(params.workitemid, stars, comments, () => { setStatus(STATUS.RATED); }, mounted);    
    setStatus(STATUS.FETCHING);
  };

  useEffect(() => {
    if(status === STATUS.NONE)
      fetchStatus();

    return () => { mounted.current = false; };
  }, []);

  return (
    <div className="customer-feedback-root">
      <Link to="/">
        <img src={logo} alt="Return to Mueller Reports" className="logo" />
      </Link>
      {(status === STATUS.NONE || STATUS === STATUS.FETCHING) && <MSpinner />}
      {status === STATUS.READY &&
        <>        
          <h3>Thank you for your order!  Please let us know how we did:</h3>
          <StarRatings 
            rating={stars}
            changeRating={(nextRating) => { setStars(nextRating); }}
            starRatedColor="#E03D4C"
            starHoverColor="#CA2030"
          />      
          <TextField
            id="rating-comments"
            label="Comments:"
            maxLength={COMMENTS_MAXLENGTH}
            rows={1}
            onChange={(val) => setComments(val)}
            resize={{min:350, max:350}}
          />
          <Button primary raised onClick={submitFeedback}>Submit</Button>
        </>
      }
      {status === STATUS.RATED &&
        <>
          <h3>Thank you for your feedback!</h3>
          <a href="https://www2.muellerreports.com/contact-us/">
            <Button primary raised>Contact Us</Button>
          </a>
        </>
      }
      {status === STATUS.EXPIRED &&
        <>
          <h3>This link has expired.  Please contact customer service with any additional feedback.</h3>
          <a href="https://www2.muellerreports.com/contact-us/">
            <Button primary raised>Contact Us</Button>
          </a>
        </>
      }
      {status === STATUS.ERROR &&
        <>
          <h3>Oops!  You appear to have reached this page in error.</h3>
          <a href="https://www2.muellerreports.com/contact-us/">
            <Button primary raised>Contact Us</Button>
          </a>
        </>
      }
    </div>  
  );
};

CustomerFeedback.propTypes = {
  match: PropTypes.object.isRequired,
  makeToast: PropTypes.func.isRequired,
};

const mapDispatchToProps = dispatch => ({
  makeToast: text => {
    responseHandler.customToast(text, "error", dispatch);
  }
});

export default connect(null, mapDispatchToProps)(CustomerFeedback);